/** Shows when Apple Wallet has registered the pass (Add, not QR scan). Copy from WalletAddQr. */
export function AppleWalletMark({ show }: { show?: boolean | null }) {
  if (!show) return null;
  return (
    <span className="status-pill wallet" title="Apple Wallet">
      Apple Wallet
    </span>
  );
}
